module.exports = __webpack_public_path__ + "static/media/abroad.ae18444a.jpg";